import React, { Component } from "react";
import styles from "./controlPoints.module.scss";
import { FormControl, Radio } from "@mui/material";
import { withAuth } from "../../../shared/containers/containerAuth";

class ViewPanelRadioControl extends Component {
  render() {
    const { onSetViewPanel, viewPanel, viewPanelItems, data } = this.props;

    const groupPermission = data.permissions.includes(46003);

    return (
      <div>
        <FormControl>
          <div className={styles.radioButtomContainer}>
            <div
              className={styles.radioButtomItem}
              onClick={() => {
                onSetViewPanel(viewPanelItems.controlPointsList);
              }}
            >
              <Radio checked={viewPanel === viewPanelItems.controlPointsList} size="small" />
              Контрольные точки
            </div>
            {groupPermission ? (
              <div
                className={styles.radioButtomItem}
                onClick={() => {
                  onSetViewPanel(viewPanelItems.groupsControlPoints);
                }}
              >
                <Radio checked={viewPanel === viewPanelItems.groupsControlPoints} size="small" />
                Контрольные точки и группы
              </div>
            ) : null}
          </div>
        </FormControl>
      </div>
    );
  }
}

export default withAuth(React.memo(ViewPanelRadioControl));
